export const categories = [
  { id: 1, value: 'General Note' },
  { id: 2, value: 'Declined services' },
  { id: 3, value: 'Awaiting documentation' },
  { id: 4, value: 'Follow up' },
  { id: 5, value: 'Attempted follow-up' },
  { id: 6, value: 'Program Track' },
  { id: 7, value: 'Progress Note' },
];
